export default __webpack_public_path__ + "static/media/spt12.2dabf7e6.png";